<template>
    <th :class="className" scope="col" :style="{ 'background-color': color }">
        <div :class="classInner" :style="{ 'color': getFontColor }"> {{text}} </div>
    </th>
</template>

<script>
const CLASS_HEADER = "mds-data-table__header-cell row-header";
const CLASS_DATA = "mds-data-table__header-cell";
const CLASS_HEADER_INNER = "mds-data-table__header-cell-inner";
const CLASS_DATA_INNER = "mds-data-table__header-cell-inner false mds-data-table__header-cell--right";

export default {
    props: {
        text: {
            type: String,
            required: true
        },
        isSticky: {
            type: Boolean
        },
        color: {
            type: String,
            default: "transparent"
        },
        fontColor: {
            type: String
        }

    },
    computed: {
        className () {
            return this.isSticky ? CLASS_HEADER : CLASS_DATA;
        },
        classInner () {
            return this.isSticky ? CLASS_HEADER_INNER : CLASS_DATA_INNER;
        },
        getFontColor () {
            return this.fontColor ? this.fontColor : false;
        }
    }
};
</script>

<style lang="scss" scoped>
div {
    color: $mds-color-neutral-37;
    padding-top: $mds-space-1-x;
}
.mds-data-table__header-cell:last-child  {
    .mds-data-table__header-cell--right{
        padding-right: $mds-space-1-x;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/TableHeading.vue